import { setCookie, parseCookies } from 'nookies'

import { getDefaultCookieOptions } from 'services/auth'

export const setSearchOriginCookie = (ctx = null) => {
	const cookies = parseCookies(ctx)

	if (!cookies.searchOrigin) {
		setCookie(ctx, 'searchOrigin', 'busca', {
			...getDefaultCookieOptions(),
			path: '/',
			maxAge: 60 * 45 // 45 minutos
		})
	}
}

export const setSearchVersionCookie = (user, ctx = null) => {
	const version = getSearchVersionFromUser(user)

	setCookie(ctx, 'searchVersion', version, {
		...getDefaultCookieOptions(),
		path: '/',
		maxAge: 60 * 45 // 45 minutos
	})
}

export const getSearchVersionCookie = (ctx = null) => {
	const cookies = parseCookies(ctx)
	return cookies.searchVersion
}

export function getSearchVersionFromUser(user) {
	if (!user?.id) return 'nao-logado'

	const formattedNumericId = String(user.id).replace(/\D/g, '')
	const numericId = formattedNumericId
		.split('')
		.reduce((acc, digit) => acc + Number(digit), 0)
	const isEvenUser = (numericId / 2) % 2 === 0
	// TODO: modificado para teste GA sobre usuários impar e par
	return isEvenUser ? 'v1' : 'v2'
}
